// import axios from 'axios';
// import { Auth } from 'aws-amplify';
import moment from 'moment';
import config from '../config'
const apigClientFactory = require('aws-api-gateway-client').default;

export async function loadIamAPI (path, method = 'GET', pathParams = {}, additionalParams = {}){
  const apigClient = apigClientFactory.newClient(config.aws);
  return await apigClient.invokeApi(pathParams, path, method, additionalParams);
}
 
/*export async function loadCognitoData (path) {
  const host = 'i4iuahxtsd.execute-api.eu-west-1.amazonaws.com';
  const token = await Auth.signIn('abennett@salmon.com', 'Temp-123')
    .then(user => user.signInUserSession.accessToken.jwtToken)
    .catch(err => console.log(err));
  return axios({
    method: 'get',
    url: 'https://' + host + path,
    headers: {
      Authorization: token
    }
  });
}*/

export function getOrderData (orderNumber) {
  return loadIamAPI(`${config.orderApi}${orderNumber}`).then(response => {
    const data = response.data;
    const locationUpdates = data.locationUpdates[0] || {};
    const deliverySummary = data.deliverySummary;
    const order = data.reservationInfo.order;
    const waypoints = data.vehicleTour || [];
    const waypoint = waypoints.find( item => item.waypointId === order.waypointId);
    const deliveryUpdates = data.deliveryUpdates || [];
    const scheduledArrival = moment(data.reservationInfo.order.arrivalTime,'HH:mm:ss').toDate();
    const actualArrival = (deliveryUpdates.reverse().find(u => u.job_outcome_time) || {}).job_outcome_time;
    const lastWaypointWithUpdates = Math.max(0,waypoints.indexOf( [...waypoints].reverse().find( item => item.outcome !== 'NO_UPDATES')));
    return {
      retailerId: order.retailerId,
      trip : {
        isUnknown : waypoint.outcome === 'UNKNOWN',
        isDelivered : waypoint.outcome === 'COMPLETED',
        isFailed : waypoint.outcome === 'FAILED',
        scheduledArrival : scheduledArrival && new Date(scheduledArrival),
        actualArrival : actualArrival && moment(new Date(actualArrival)).utc(true).toDate(),
        customerIndex : 1 + waypoints.indexOf(waypoint),
        currentIndex : 1 +  waypoints.indexOf(waypoints.slice(lastWaypointWithUpdates).find( item => item.outcome === 'NO_UPDATES')),
        allWaypoints : waypoints.length
      },
      customer : {
        customerName: order.customerName,
        postcode: order.location.postcode
      },
      currentLocation : {
        isWithoutGPS : !locationUpdates.latitude || !locationUpdates.longitude,
        lat : locationUpdates.latitude,
        long : locationUpdates.longitude
      },
      customerLocation : {
        lat : order.location.latitude,
        long : order.location.longitude,
        scheduledArrival : order.arrivalTime,
        scheduledDeparture : order.departureTime,
        scheduledDepartureTS : deliverySummary.scheduledTime,
        actualDepartureTS : deliverySummary.actualTime,
      },
    }
  });
}
